import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';

// Context Providers
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { getToken } from 'firebase/messaging';
import { messaging, db, doc, setDoc } from './components/firebase';

// Components
import Navbar from './components/Navbar';
import LandingNavbar from './components/LandingNavbar';
import ScrollToTop from './components/ScrollToTop';
import LoaderAnimation from './components/LoaderAnimation';
import BackgroundAnimationTwo from './components/BackgroundAnimationTwo';
import AppRoutes from './routes/AppRoutes';

const AppContent = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const requestPermission = async () => {
      if (!isAuthenticated || !user || !messaging) return;

      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

          if (!vapidKey || vapidKey === 'VAPID_KEY_PLACEHOLDER') {
            console.log('FCM token registration skipped: Valid REACT_APP_FIREBASE_VAPID_KEY is missing in .env');
            return;
          }

          const token = await getToken(messaging, { vapidKey });

          if (token) {
            await setDoc(doc(db, 'Users', user.uid), {
              fcmToken: token,
              lastTokenUpdate: new Date()
            }, { merge: true });
            console.log('FCM Token registered');
          }
        }
      } catch (error) {
        console.error('Error requesting notification permission:', error);
      }
    };

    requestPermission();
  }, [isAuthenticated, user]);

  const hideNavbarPaths = ['/portfolio/', '/admin', '/tutorial/'];
  const guestPages = ['/', '/about', '/tech-library', '/job-portal', '/ipu-result', '/contactus', '/notification', '/feedback', '/terms & condition', '/privacy-policy'];
  const isLandingPath = guestPages.some(path => location.pathname === path || location.pathname.startsWith(path + '/'));

  const showLandingNavbar = !isAuthenticated && isLandingPath;
  const showDashboardNavbar = isAuthenticated && !hideNavbarPaths.some(p => location.pathname.startsWith(p));

  if (loading && showLoader) {
    return <LoaderAnimation onComplete={() => setShowLoader(false)} />;
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#021526' }}>
        <div style={{ width: 40, height: 40, border: '3px solid rgba(0,255,255,0.2)', borderTopColor: '#00ffff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  return (
    <>
      {showLoader && <LoaderAnimation onComplete={() => setShowLoader(false)} />}
      <ScrollToTop />
      {showLandingNavbar && <LandingNavbar />}
      {showDashboardNavbar && <Navbar />}

      <AppRoutes />

      <BackgroundAnimationTwo />
    </>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
